// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Base App styles */
.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #202020;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #1192DC;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Modern background styles */
.bg-gradient {
  background: linear-gradient(135deg, #1192DC, #202020);
  position: relative;
}

.bg-pattern {
  background-image: 
    radial-gradient(#ffffff 1px, transparent 1px), 
    radial-gradient(#ffffff 1px, transparent 1px);
  background-size: 40px 40px;
  background-position: 0 0, 20px 20px;
  height: 100%;
  width: 100%;
}

.bg-grid {
  background-image: 
    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
  background-size: 40px 40px;
  background-position: center center;
  height: 100%;
  width: 100%;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes slideInUp {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes shimmer {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.7; }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease forwards;
}

.animate-slideInUp {
  animation: slideInUp 0.4s ease forwards;
}

.animate-shimmer {
  animation: shimmer 2s infinite;
}

.animate-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

/* Form styling */
input[type="text"], 
input[type="password"],
input[type="email"] {
  transition: all 0.2s ease;
}

input[type="text"]:focus, 
input[type="password"]:focus,
input[type="email"]:focus {
  border-color: #1192DC;
}

input[type="checkbox"] {
  position: relative;
  cursor: pointer;
}

input[type="checkbox"]:checked {
  background-color: #1192DC;
  border-color: #1192DC;
}

button {
  position: relative;
  overflow: hidden;
  transition: all 0.2s ease;
}

button:active {
  transform: scale(0.98);
}

/* Glass morphism */
.glass {
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);
}

.button-shadow {
  box-shadow: 0 2px 10px rgba(17, 146, 220, 0.2);
}

.button-shadow:hover {
  box-shadow: 0 4px 15px rgba(17, 146, 220, 0.3);
}

/* Custom scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

::-webkit-scrollbar-thumb:hover {
  background: #a1a1a1;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,6BAA6B;AAC7B;EACE,qDAAqD;EACrD,kBAAkB;AACpB;;AAEA;EACE;;iDAE+C;EAC/C,0BAA0B;EAC1B,mCAAmC;EACnC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;;0EAEwE;EACxE,0BAA0B;EAC1B,kCAAkC;EAClC,YAAY;EACZ,WAAW;AACb;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,KAAK,4BAA4B,EAAE;EACnC,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,WAAW,UAAU,EAAE;EACvB,MAAM,YAAY,EAAE;AACtB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;;;EAGE,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,0CAA0C;EAC1C,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* Base App styles */\n.App {\n  text-align: center;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #202020;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #1192DC;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Modern background styles */\n.bg-gradient {\n  background: linear-gradient(135deg, #1192DC, #202020);\n  position: relative;\n}\n\n.bg-pattern {\n  background-image: \n    radial-gradient(#ffffff 1px, transparent 1px), \n    radial-gradient(#ffffff 1px, transparent 1px);\n  background-size: 40px 40px;\n  background-position: 0 0, 20px 20px;\n  height: 100%;\n  width: 100%;\n}\n\n.bg-grid {\n  background-image: \n    linear-gradient(rgba(255, 255, 255, 0.05) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.05) 1px, transparent 1px);\n  background-size: 40px 40px;\n  background-position: center center;\n  height: 100%;\n  width: 100%;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes slideInUp {\n  from { opacity: 0; transform: translateY(20px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes shimmer {\n  0% { transform: translateX(-100%); }\n  100% { transform: translateX(100%); }\n}\n\n@keyframes pulse {\n  0%, 100% { opacity: 1; }\n  50% { opacity: 0.7; }\n}\n\n.animate-fadeIn {\n  animation: fadeIn 0.3s ease forwards;\n}\n\n.animate-slideInUp {\n  animation: slideInUp 0.4s ease forwards;\n}\n\n.animate-shimmer {\n  animation: shimmer 2s infinite;\n}\n\n.animate-pulse {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n/* Form styling */\ninput[type=\"text\"], \ninput[type=\"password\"],\ninput[type=\"email\"] {\n  transition: all 0.2s ease;\n}\n\ninput[type=\"text\"]:focus, \ninput[type=\"password\"]:focus,\ninput[type=\"email\"]:focus {\n  border-color: #1192DC;\n}\n\ninput[type=\"checkbox\"] {\n  position: relative;\n  cursor: pointer;\n}\n\ninput[type=\"checkbox\"]:checked {\n  background-color: #1192DC;\n  border-color: #1192DC;\n}\n\nbutton {\n  position: relative;\n  overflow: hidden;\n  transition: all 0.2s ease;\n}\n\nbutton:active {\n  transform: scale(0.98);\n}\n\n/* Glass morphism */\n.glass {\n  background-color: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.1);\n}\n\n.button-shadow {\n  box-shadow: 0 2px 10px rgba(17, 146, 220, 0.2);\n}\n\n.button-shadow:hover {\n  box-shadow: 0 4px 15px rgba(17, 146, 220, 0.3);\n}\n\n/* Custom scrollbar */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb {\n  background: #c1c1c1;\n  border-radius: 10px;\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: #a1a1a1;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
